import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BotaoDuplo from '../../../Componentes/BotaoDuplo';
import CampoEdicoes from '../../../Componentes/CampoEdicoes';
import CorpoPagina from '../../../Componentes/CorpoPagina';
import ModalConfirmacao from '../../../Componentes/ModalConfirmacao';
import TextInput from '../../../Componentes/TextInput';
import TopicoTexto from '../../../Componentes/TopicoTexto';
import { apiService } from '../../../Services/ApiService';
import { ModalView } from '../../../Componentes';
import { ModalTópico } from '../../../Componentes/ModalView';
import { useTranslation } from 'react-i18next';
import { StoreContexto } from '../../../Contexto/Provider';
import { useContext } from 'react';

export default function AlertaCadastro() {
  const navega = useNavigate();
  const { id } = useParams();
  const { get, post } = apiService();
  const [alert, setAlert] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  const [modalComment, setModalComment] = useState(false);
  const [modalSuccess, setModalSuccess] = useState({
    visible: false,
    message: '',
  });

  const [modalError, setModalError] = useState({
    visible: false,
    message: '',
  });

  const [comment, setComment] = useState('');


  const { auth } = useContext(StoreContexto);

  const { t: tVar } = useTranslation('variables');
  const { t: tAlertNature } = useTranslation('alertNature');

  const getVariableUnit = (variable) => {
    switch (variable) {
      case 'TEMPERATURE':
        return '°C';
      case 'HUMIDITY':
        return '%';
      case 'END_OF_COURSE':
        return 's';
      default:
        return '';
    }
  }

  useEffect(() => {
    if (id) {
      fetchAlert();
    } else {
      setIsLoading(false);
    }
  }, [id]);

  const fetchAlert = async () => {
    setIsLoading(true);
    try {
      const data = await get(`alerts/${id}`);
      if (data) {
        const alert = {
          environmentName: data.environment.name,
          endnodeId: data.endnodeId,
          date: new Date(data.createdAt).toLocaleDateString(),
          createdAt: data.createdAt,
          finishedAt: data.finishedAt,
          variableName: tVar(data.variable).toUpperCase(),
          minValue: data.minValue,
          maxValue: data.maxValue,
          value: data.value,
          comments: data.comments ? data.comments : [],
          nature: tVar(data.nature) ?? null,
          description: data.description ?? null,
          descriptionAuthorName: data.descriptionAuthor?.name ?? null,
          descriptionDate: data.descriptionUpdatedAt ?? null,
          unit: getVariableUnit(data.variable),
        };

        setAlert(alert);
      }
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar os detalhes do alerta' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleModalComment = () => {
    setModalComment(true);
  };

  const handleComment = async (save) => {
    if (save) {
      try {
        const data = await post(`alerts/comment/${id}`, { comment });
        if (data) {
          setModalComment(false);
          setModalSuccess({ visible: true, message: 'Comentário salvo com sucesso' });
          fetchAlert();
        }
      } catch (error) {
        setModalError({ visible: true, message: 'Erro ao salvar o comentário' });
      }
    }
    setModalComment(false);
  };

  return (
    <CorpoPagina loading={isLoading}>
      {modalError.visible && (
        <ModalConfirmacao
          aviso={modalError.message}
          erro={true}
          clicado={() => setModalError({ visible: false, message: '' })}
        />
      )}

      {modalComment && (
        <ModalView height={'100%'} width={'100%'}>
          <ModalTópico titulo="Alertas" />
          <textarea
            style={{
              fontFamily: 'montserrat',
              fontSize: 16,
              width: 450,
              height: 100,
              borderRadius: 5,
              border: '1px solid #005288',
              padding: 8,
              resize: 'none',
              marginBottom: 32,
              marginTop: 32,
            }}
            placeholder="Faça um comentário com até 200 caracteres"
            maxLength={200}
            onChange={(e) => setComment(e.target.value)}
          />
          <BotaoDuplo
            externo
            clicado={() => handleComment(true)}
            clicadoVolta={() => handleComment(false)}
            nome="Comentar"
            nomeVolta="Cancelar"
          />
        </ModalView>
      )}

      <div
        className="ContainerGeral"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'flex-start',
          justifyContent: 'flex-start',
        }}
      >
        <TopicoTexto titulo={'Visualizar Alerta'} marginLeft={15} />
        <div className="form-row">
          <div className="form-column" style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <CampoEdicoes
              titulo="DADOS DO ALERTA"
              maxHeight={'fit-content'}
              maxW={600}
              width={'100%'}
              minWidth={150}
            >
              <TextInput
                titulo="Localização"
                padrao={alert.environmentName}
                tipo="input"
                largura="90%"
                top={8}
                disabled={true}
              />
              <TextInput
                titulo="ID"
                padrao={alert.endnodeId}
                tipo="input"
                largura="90%"
                top={8}
                disabled={true}
              />
              <TextInput
                titulo="Data da ocorrência"
                padrao={alert.date}
                tipo="input"
                largura="90%"
                top={8}
                disabled={true}
              />
              <div
                className="form-row"
                style={{
                  paddingBottom: 20,
                  display: 'flex',
                  alignContent: 'space-between',
                  flexWrap: 'wrap',
                }}
              >
                <div
                  className="form-column"
                  style={{
                    marginLeft: 0,
                    marginRight: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    width: '47.5%',
                  }}
                >
                  <TextInput
                    titulo="Início do alerta"
                    padrao={new Date(alert.createdAt).toLocaleTimeString()}
                    tipo="input"
                    largura="90%"
                    top={8}
                    disabled={true}
                  />
                </div>
                <div
                  className="form-column"
                  style={{
                    marginLeft: 0,
                    marginRight: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    width: '47.5%',
                  }}
                >
                  <TextInput
                    titulo="Fim do alerta"
                    padrao={alert.finishedAt ? new Date(alert.finishedAt).toLocaleTimeString() : ''}
                    tipo="input"
                    largura="90%"
                    top={8}
                    disabled={true}
                  />
                </div>
              </div>
            </CampoEdicoes>
            <CampoEdicoes
              titulo={alert.variableName}
              width={'100%'}
              minWidth={150}
              marginTop={24}
              marginBottom={20}
            >
              <div className="form-row" style={{ paddingBottom: 20 }}>
                <div className="form-column" style={{ marginLeft: 20, marginRight: 10 }}>
                  <TextInput
                    titulo="Valor mínimo"
                    padrao={alert.minValue + ` ${alert.unit}`}
                    tipo="input"
                    largura="100%"
                    top={8}
                    disabled={true}
                    marginLeft={10}
                    marginRight={10}
                  />
                </div>
                <div className="form-column" style={{ marginLeft: 10, marginRight: 10 }}>
                  <TextInput
                    titulo="Valor máximo"
                    padrao={alert.maxValue + ` ${alert.unit}`}
                    tipo="input"
                    largura="100%"
                    top={8}
                    disabled={true}
                    marginLeft={10}
                    marginRight={10}
                  />
                </div>
                <div className="form-column" style={{ marginLeft: 10, marginRight: 20 }}>
                  <TextInput
                    titulo="Encontrado"
                    padrao={Number(alert.value).toFixed(2) + ` ${alert.unit}`}
                    tipo="input"
                    largura="100%"
                    top={8}
                    disabled={true}
                    marginLeft={10}
                    marginRight={10}
                    color="#cd6456"
                  />
                </div>
              </div>
            </CampoEdicoes>
          </div>

          <div className="form-column" style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <CampoEdicoes
              titulo="COMENTÁRIOS"
              maxHeight={700}
              maxW={540}
              width={'100%'}
              overflowY="scroll"
            >
              {alert.nature && alert.description && (
                <div
                  className="comment-container"
                  style={{
                    backgroundColor: '#efefef',
                    borderRadius: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    marginBottom: 10,
                  }}
                >
                  <div
                    className="comment-header"
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'right',
                      fontSize: 12,
                      color: '#a7a7a7',
                      paddingRight: 10,
                    }}
                  >
                    {`comentário feito em ${new Date(
                      alert.descriptionDate,
                    ).toLocaleDateString()}, ${new Date(
                      alert.descriptionDate,
                    ).toLocaleTimeString()}`}
                  </div>
                  <div
                    className="comment-author"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      paddingLeft: 20,
                      paddingRight: 20,
                      fontSize: 16,
                      fontWeight: 'bold',
                      wordWrap: 'break-word',
                      wordBreak: 'break-all',
                    }}
                  >
                    {alert.descriptionAuthorName}
                  </div>
                  <div
                    className="comment-text"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      padding: 20,
                      fontSize: 14,
                      wordWrap: 'break-word',
                      wordBreak: 'break-all',
                    }}
                  >
                    {alert.description}
                  </div>
                  <div
                    className="comment-nature"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      paddingLeft: 20,
                      paddingRight: 20,
                      paddingBottom: 20,
                      fontSize: 12,
                      color: '#a7a7a7',
                    }}
                  >
                    <i>{tAlertNature(alert.nature)}</i>
                  </div>
                </div>
              )}
              {alert.comments &&
                alert.comments.map((comment, index) => (
                  <div
                    className="comment-container"
                    style={{
                      backgroundColor: '#efefef',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      marginBottom: 10,
                    }}
                  >
                    <div
                      className="comment-header"
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'right',
                        fontSize: 12,
                        color: '#a7a7a7',
                        paddingRight: 10,
                      }}
                    >
                      {`comentário feito em ${new Date(
                        comment.createdAt,
                      ).toLocaleDateString()}, ${new Date(comment.createdAt).toLocaleTimeString()}`}
                    </div>
                    <div
                      className="comment-author"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingLeft: 20,
                        paddingRight: 20,
                        fontSize: 16,
                        fontWeight: 'bold',
                        wordWrap: 'break-word',
                        wordBreak: 'break-all',
                      }}
                    >
                      {comment.user.name}
                    </div>
                    <div
                      className="comment-text"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 20,
                        fontSize: 14,
                        wordWrap: 'break-word',
                        wordBreak: 'break-all',
                      }}
                    >
                      {comment.comment}
                    </div>
                  </div>
                ))}
              {!alert.comments ||
                (alert.comments.length === 0 && (
                  <div
                    className="comment-container"
                    style={{
                      backgroundColor: '#efefef',
                      borderRadius: 5,
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      borderBottom: '1px solid white',
                    }}
                  >
                    <div
                      className="comment-header"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 20,
                        fontSize: 14,
                      }}
                    >
                      {`Nenhum comentário`}
                    </div>
                  </div>
                ))}
            </CampoEdicoes>
            { (auth.perfilSalvo === 'OWNER' || auth.perfilSalvo === 'OPERATOR') && (
              <button style={{ margin: 30 }} id="BotaoCadastro" onClick={() => handleModalComment()}>
                Comentar
              </button>
             )}
          </div>
        </div>
        <button style={{ margin: 30 }} id="BotaoCadastro" onClick={() => navega(-1)}>
          Voltar
        </button>
      </div>
    </CorpoPagina>
  );
}
